import {FEATURE_FLAGS, MODULE_TYPES} from '../../../constants';
import {hasFeatureFlag} from './FeatureUtil';
import {hasModule} from './ModuleUtil';

/**
 * Whether embedded ticketing is *available* to the current company/person.
 *
 * Ticketing is gated by EITHER the `TICKETING` module OR the `tickets_enabled`
 * feature flag (ACC-461): module customers get it automatically, while the flag
 * lets us grant access to individual users/companies without the module (e.g.
 * internal dogfooding / staged rollout).
 *
 * This only governs *availability* — per-person *access* is still gated
 * separately by the `TICKETS_VIEW` / `TICKETS_CREATE` / `TICKETS_ADMIN`
 * permissions, which callers must check alongside this.
 */
export const isTicketingAvailable = (): boolean => hasModule(MODULE_TYPES.TICKETING) || hasFeatureFlag(FEATURE_FLAGS.TICKETS);
